import type { ComponentProps } from "react";
import type { Text } from "react-native-paper";

// RN's TextProps don't declare accessibilityLevel/aria-level, but react-native-web
// reads accessibilityLevel to render <h1>-<h6> on web (propsToAccessibilityComponent.js).
type HeadingLevel = 1 | 2 | 3;
export const headingProps = (level: HeadingLevel) =>
	({
		accessibilityRole: "header",
		accessibilityLevel: level,
	}) as unknown as Partial<ComponentProps<typeof Text>>;
